import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=032d2442&scoped=true&"
import script from "./Facilities.vue?vue&type=script&lang=ts&"
export * from "./Facilities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d2442",
  null
  
)

export default component.exports